export default __webpack_public_path__ + "static/media/ic_idea.2424efb2.svg";